module.exports = __webpack_public_path__ + "static/media/bring-it-1.fd9a52f4.JPG";